import {Provider} from '@angular/core';

import {
  GetUsuryRateUseCaseProvider
} from '@features/setting/presentation/providers/get-usury-rate/get-usury-rate.use-case.provider';

import {GetUsuryRateFacade} from '@features/setting/presentation/facades/get-usury-rate/get-usury-rate.facade';

export const GetUsuryRateFacadeProvider: Provider[] = [
  GetUsuryRateUseCaseProvider,
  GetUsuryRateFacade
];
